export default "__VITE_ASSET__548d486e__"